"use client";

import { useEffect } from "react";

// Publishable key (Branch dashboard → Security & Access → "Branch Key"); it
// ships to every browser by design. Never put the Branch *Secret* here.
const BRANCH_KEY = "key_live_lwvUfNsDnkePMhNgYdMJ6clnyqncS6IS";

// Survives React Strict Mode's double effect run, so init happens once.
let initialized = false;

export default function BranchTracker() {
  useEffect(() => {
    if (initialized) return;
    initialized = true;

    // The SDK touches `window` at import time, so it must only load in the browser.
    import("branch-sdk")
      .then(({ default: branch }) => {
        branch.init(BRANCH_KEY, (err: unknown) => {
          if (err) console.error("Branch init failed:", err);
        });
      })
      .catch((err) => console.error("Branch SDK failed to load:", err));
  }, []);

  return null;
}
